import React from "react";

const TailormedLogoIcon = () => {
  return (
    <svg width="115" height="20" viewBox="0 0 135 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_426_306)">
        <path d="M6.1495 1.81005V19.5791H4.9029V1.81005H0V0.676483H11.0518V1.81005H6.1495Z" fill="#191938" />
        <path
          d="M22.3013 13.3724H14.2533L11.7312 19.579H10.371L18.3342 0.109375L26.1837 19.579H24.8234L22.3013 13.3724ZM21.8479 12.2388L18.3059 3.28335L14.7068 12.2388H21.8479Z"
          fill="#191938"
        />
        <path d="M30.3776 0.676483V19.5791H29.131V0.676483H30.3776Z" fill="#191938" />
        <path d="M36.7255 0.676483V18.4455H41.9964V19.5791H35.4789V0.676483H36.7255Z" fill="#191938" />
        <path
          d="M62.6568 10.1702C62.6568 15.6113 58.3782 19.8905 52.8523 19.8905C47.3264 19.8905 43.0478 15.6113 43.0478 10.1702C43.0478 7.5697 44.0805 5.07522 45.9193 3.23647C47.758 1.39772 50.2519 0.364349 52.8523 0.364349C55.4528 0.364349 57.9466 1.39772 59.7853 3.23647C61.6241 5.07522 62.6568 7.5697 62.6568 10.1702ZM61.3531 10.1702C61.3531 5.32377 57.7257 1.55507 52.8517 1.55507C47.9777 1.55507 44.3503 5.32441 44.3503 10.1702C44.3503 15.0159 47.9777 18.757 52.8517 18.757C57.7257 18.757 61.3531 14.9876 61.3531 10.1702Z"
          fill="#191938"
        />
        <path
          d="M74.6694 19.5791L68.5488 10.6518H67.9817V19.5791H66.7351V0.676483H69.455C70.9007 0.676483 72.2038 0.790161 73.451 1.63985C74.9244 2.66038 75.406 4.21847 75.406 5.69242C75.406 7.56264 74.5846 9.49002 72.2321 10.2832C71.4832 10.5317 70.6984 10.6563 69.9084 10.6518L76.0862 19.5791H74.6694ZM67.9817 9.51828H69.7954C72.4877 9.51828 74.1029 8.10148 74.1029 5.66416C74.1029 3.76568 73.1678 2.77341 72.4305 2.37651C71.6373 1.92308 70.2771 1.8094 69.5404 1.8094H67.9817V9.51763V9.51828Z"
          fill="#191938"
        />
        <path
          d="M78.6365 19.5791L81.6686 0.676483H85.296L89.9998 11.9839L94.7042 0.676483H98.331L101.364 19.5791H96.9996L95.4974 8.29994L90.7653 19.5791H89.2349L84.5028 8.29994L83.0006 19.5791H78.6365Z"
          fill="#191938"
        />
        <path
          d="M115.306 4.3604H108.986V8.01606H114.993V11.7H108.986V15.8945H115.306V19.5784H104.622V0.676483H115.306V4.3604Z"
          fill="#191938"
        />
        <path
          d="M124.827 0.676483C127.321 0.676483 129.956 1.04513 132.279 3.284C133.951 4.89925 135 7.10986 135 10.0571C135 13.0044 133.98 15.1867 132.421 16.7455C129.815 19.3812 126.555 19.5797 124.969 19.5797H118.848V0.676483H124.827ZM123.212 15.8951H124.373C125.28 15.8951 127.264 15.8104 128.681 14.6196C129.701 13.7693 130.523 12.1541 130.523 10.0571C130.523 7.96019 129.701 6.71295 128.964 5.97629C127.547 4.5595 125.705 4.36105 124.373 4.36105H123.212V15.8945V15.8951Z"
          fill="#191938"
        />
      </g>
      <defs>
        <clipPath id="clip0_426_306">
          <rect width="135" height="19.7812" fill="white" transform="translate(0 0.109375)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { TailormedLogoIcon };
